@if (clientMode !== 'funds') {
    @if (clientMode === 'single-client') {
        <cc-single-select-dropdown
            [label]="'client'"
            [anchorType]="'filter'"
            [anchorAlignment]="'right'"
            [emitOnCloseOnly]="true"
            [options]="clientOptions"
            [searchable]="true"
            [(selected)]="selectedClientOption"
            (selectedChange)="onSelectedClientChanged()"
        >
        </cc-single-select-dropdown>
    } @else {
        <cc-multi-select-dropdown
            [label]="'clients'"
            [anchorType]="'filter'"
            [anchorAlignment]="'right'"
            [emitOnCloseOnly]="true"
            [options]="clientOptions"
            [searchable]="true"
            [(selected)]="selectedClientsOptions"
            (selectedChange)="onSelectedClientsChanged()"
        >
        </cc-multi-select-dropdown>
    }
} @else {
    <cc-fund-multi-select-dropdown
        [label]="'funds'"
        [anchorType]="'filter'"
        [anchorAlignment]="'right'"
        [emitOnCloseOnly]="true"
        [customWidth]="55"
        [showClearButton]="true"
        [funds]="funds"
        [(selected)]="selectedFunds"
        (selectedChange)="selectedFundsChange.emit($event)"
    >
    </cc-fund-multi-select-dropdown>
}

@if (dateMode !== 'none') {
    @if (dateMode === 'date-range') {
        <cc-date-range-select-dropdown
            [labels]="dateRangeLabels"
            [anchorType]="'filter'"
            [dropdownPosition]="'bottom-right'"
            [displayCommonDate]="true"
            [format]="'calendar'"
            [emitOnCloseOnly]="true"
            [allowNoSelection]="true"
            [fuzzies]="fuzzyDates"
            [(dateRange)]="dateRange"
            [periodStatuses]="periodStatuses"
            (dateRangeChange)="onDateRangeChanged()"
        >
        </cc-date-range-select-dropdown>
    } @else {
        <cc-date-select-dropdown
            [label]="dateLabel"
            [anchorType]="'filter'"
            [dropdownPosition]="'bottom-right'"
            [displayCommonDate]="true"
            [format]="'calendar'"
            [emitOnCloseOnly]="true"
            [allowNoSelection]="true"
            [fuzzies]="fuzzyDates"
            [(value)]="date"
            [periodStatuses]="periodStatuses"
            (valueChange)="onDateChanged()"
        >
        </cc-date-select-dropdown>
    }
}
